import { render, staticRenderFns } from "./DynamicResidentialProxy.vue?vue&type=template&id=b8fa523c&scoped=true"
import script from "./DynamicResidentialProxy.vue?vue&type=script&lang=js"
export * from "./DynamicResidentialProxy.vue?vue&type=script&lang=js"
import style0 from "./DynamicResidentialProxy.vue?vue&type=style&index=0&id=b8fa523c&prod&lang=less"
import style1 from "./DynamicResidentialProxy.vue?vue&type=style&index=1&id=b8fa523c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa523c",
  null
  
)

export default component.exports